export function getQuery() {
  return new URLSearchParams(window.location.search)
}
